import { Pipe, PipeTransform, Injector } from '@angular/core';
import {ActionTypePipe} from "./action-type.pipe";
import {EventTypePipe} from "./event-type.pipe";

@Pipe({
    name: 'dynamicPipe'
})
export class DynamicPipe implements PipeTransform {

    private pipeMap = new Map<string, PipeTransform>();

    constructor(private injector: Injector) {
        this.pipeMap.set('EventType', new EventTypePipe());
        this.pipeMap.set('ActionType', new ActionTypePipe());
    }

    transform(value: any, pipeName: string, ...args: any[]): any {
        if (!pipeName) return value;

        const pipe = this.pipeMap.get(pipeName);

        if (pipe) {
            return pipe.transform(value, ...args);
        }
    }
}
